import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import FullScreenLoader from './FullScreenLoader';

function SalonProtectedRoute({ children }) {
  const { currentUser, userRole, loading } = useAuth();

  // Show loader while determining auth state
  if (loading) {
    return <FullScreenLoader />;
  }

  // If not logged in, redirect to login
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  // If user is admin, redirect to admin dashboard
  if (userRole === 'admin') {
    return <Navigate to="/bookings" replace />;
  }

  // If role is not determined yet or not salon, wait or redirect
  if (userRole !== 'salon') {
    // Role not determined yet, show loader
    return <FullScreenLoader />;
  }

  return children;
}

export default SalonProtectedRoute;















